// extracted by mini-css-extract-plugin
module.exports = {"savedAddress":"SavedAddress__savedAddress___3d1pZ","pencil":"SavedAddress__pencil___27Fje"};